<h1 mat-dialog-title>
  <app-draggable-dialog-handle/>
  Client {{ data.client.name }}
</h1>
<div mat-dialog-content>
  <form [formGroup]="editForm" class="client-edit-form">
    <div formArrayName="people">
      <ng-container *ngFor="let personForm of people.controls; let i = index">
        <div [formGroup]="personForm" class="person-row">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input formControlName="name" matInput type="text">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Phone</mat-label>
            <input formControlName="phone" matInput type="tel">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Email</mat-label>
            <input formControlName="email" matInput type="email">
          </mat-form-field>
          <button (click)="removePerson(i)" mat-icon-button title="Remove" type="button">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </ng-container>
    </div>
    <button (click)="addPerson()" class="add" mat-button type="button">
      <mat-icon>add</mat-icon>
      Add person
    </button>
  </form>
</div>
<div mat-dialog-actions>
  <button (click)="onCancelClick()" [color]="editForm.dirty ? 'warn' : ''" mat-button>Cancel</button>
  <button (click)="onSaveClick()" color="primary" mat-raised-button>Save</button>
  <mat-error *ngIf="apiError" class="api-error">{{ apiError }}</mat-error>
</div>
